import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from './components/signin/signin.component';
import { ForgotPasswordComponent } from './components/forgot-password.component';
import { SinginAsComponent } from './components/singin-as.component';
import { ResetPasswordComponent } from './components/reset-password.component';
import { PasswordCodeComponent } from './components/password-code.component';
import { NoauthGuard } from '../services/noauth.guard';
import { AuthGuard } from '../services/auth.guard';
import { SignoutComponent } from './components/signout/signout.component';

const routes: Routes = [
  { path: 'signin', component: SigninComponent, canActivate: [NoauthGuard] },
  { path: 'signin-as', component: SinginAsComponent, canActivate: [NoauthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoauthGuard] },
  { path: 'code-confirm', component: PasswordCodeComponent, canActivate: [NoauthGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [NoauthGuard] },
  { path: 'signout', component: SignoutComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignRoutingModule { }
